import { createAction } from '@ngrx/store';

export const resetCartStateFlags = createAction('[Cart] Reset Cart State Flags');
